import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useAppDispatch } from '@/store'

import { selectRoadSegmentMapStyles, setCustomMapStyle } from '@/features/domain/ui'

export const useVisibility = (id: string): [boolean, React.MouseEventHandler<HTMLDivElement>] => {
  const dispatch = useAppDispatch()
  const mapStyles = useSelector(selectRoadSegmentMapStyles)

  const globalStyle = mapStyles.mode
  const customStyle = mapStyles.custom[id]
  const mode = customStyle || globalStyle

  return [
    mode !== 'off',
    useCallback(
      e => {
        e.stopPropagation()
        dispatch(
          setCustomMapStyle({
            customStyle: { type: 'roadSegment', mode: mode !== 'off' ? 'off' : 'on', ids: [id] },
          }),
        )
      },
      [mode, dispatch, id],
    ),
  ]
}
